export default __webpack_public_path__ + "static/subset-UniNeueRegular-Italic-29360ae1880580807e16e7b51e67a506.woff2";